var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mt-3 mb-5"},[_c('h3',{staticClass:"lesson-subheading"},[_vm._v("Focus on strategies: 20 to 100 heads")]),_c('hr',{staticClass:"subheading-separator"}),_c('app-strategies-app',{attrs:{"min":20,"max":100}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }